export default function formatDate(inputDate) {
  const date = new Date(parseFloat(inputDate) * 1000);
  return new Intl.DateTimeFormat('fi-FI', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}
